import SVG from 'react-inlinesvg';
import styled from 'styled-components';

import useSvgImage from '../../hooks/useSvgImage';
import { SlideElementSvgType } from './slide.types';
import { replacefigureColors } from './slideUtil';

const SlideElementSvg = ({
  element,
  isAuthenticated,
  isDiscoverTemplate,
  isOwner,
}: {
  element: SlideElementSvgType;
  isAuthenticated: boolean;
  isDiscoverTemplate: boolean;
  isOwner: boolean;
}) => {
  const { svgValue, mediaFileId, colors, id } = element;
  //make a new colors array so it triggers the memo in useSvgImage when colors change
  const colorsArray = [...colors];
  const { svgText } = useSvgImage({
    fileId: mediaFileId,
    fileMimetype: 'image/svg+xml',
    isDiscoverTemplate: isDiscoverTemplate,
    isAuthenticated: isAuthenticated,
    isOwner: isOwner,
    colors: colorsArray,
  });

  const code = replacefigureColors(svgValue, colors);
  if (!code && !mediaFileId) return null;
  if (mediaFileId) {
    return (
      <SlideElementSvgContainer>
        <SVG src={svgText} width={'100%'} height={'100%'} key={id} />
      </SlideElementSvgContainer>
    );
  }

  return (
    <SlideElementSvgContainer>
      <SVG src={code} width={'100%'} height={'100%'} key={id} />
    </SlideElementSvgContainer>
  );
};

const SlideElementSvgContainer = styled.div<{ $color?: string; $clipPath?: string }>`
  width: 100%;
  height: 100%;
`;

export default SlideElementSvg;
